import { render, staticRenderFns } from "./complaintHistory.vue?vue&type=template&id=e576d31a&scoped=true&"
import script from "./complaintHistory.vue?vue&type=script&lang=js&"
export * from "./complaintHistory.vue?vue&type=script&lang=js&"
import style0 from "./complaintHistory.vue?vue&type=style&index=0&id=e576d31a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e576d31a",
  null
  
)

export default component.exports